<template>
    <div>
        <b-row>
            <b-col lg="12">
                <button @click="addQuestion" class="btn btn-primary mb-1">اضافة سؤال</button>

            </b-col>
        </b-row>
        <div v-for="(question, i) in questions" v-if="questions && questions.length > 0" class="mt-2">
            <b-row>
                <b-col lg="6">
                    <h5 class="mb-1">سؤال {{ i + 1 }}</h5>
                </b-col>
                <b-col lg="6" class="text-right">
                    <button @click="removeQuestion(i)" class="btn btn-danger">حذف</button>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6">
                    <b-form-group label="صاحب السؤال">
                        <b-form-input v-model="question.owner"></b-form-input>

                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6">
                    <b-form-group label="النوع">
                        <b-form-select v-model="question.type" :options="types" />
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="الثمرات التعليمية">
                        <b-form-select v-model="question.education_results" :options="[1, 2, 3, 4]" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6">
                    <b-form-group label="الصعوبة">
                        <b-form-select v-model="question.difficulty" :options="[
                            'بسيط',
                            'متوسط',
                            'صعب'
                        ]" />
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="القدرة العقلية">
                        <b-form-select v-model="question.cognitive_ability" :options="[
                            'حفظ',
                            'تطبيق',
                            'تحليل',
                            'تركييم',
                            'تقوييم',
                            'فهم استدلال',
                            'فهم تفسير',
                            'فهم ترجمة'
                        ]" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12">
                    <b-form-group label="السؤال">
                        <b-form-textarea v-model="question.question" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6">
                    <b-form-group label="الدرجة">
                        <b-form-input type="number" v-model="question.mark" />
                    </b-form-group>
                </b-col>

            </b-row>
            <!-- <b-row v-if="question.type == 'توصيل الأجابة الصحيحة'">
                <b-col lg="6" v-for="(anwer, i) in question.type_1_answers">
                    <b-form-group label="الاجابة">
                        <b-form-input v-model="question.type_1_answers[i]" />
                    </b-form-group>
                </b-col>
            </b-row> -->
            <b-row v-if="question.type == 'صح و خطأ'">
                <b-col lg="6">
                    <b-form-group label="الاجابة">
                        <b-form-select v-model="question.type_2_answer" :options="['صح', 'خطأ']" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="question.type == 'متعدد الأختيارات و اجابات'">
                <b-col lg="6" v-for="(answer, i) in question.type_3_answers" :key="i">
                    <b-row>
                        <b-col lg="6">
                            <b-form-group label="الاجابة">
                                <b-form-input v-model="question.type_3_answers[i].answer" />
                            </b-form-group>
                        </b-col>
          
                        <b-col lg="6">
                       <b-form-checkbox v-model="question.correctAnswersIndexes" :value="i" class="mt-2">صحيحة</b-form-checkbox>

                        </b-col>
                    
                    </b-row>
                </b-col>
            </b-row>
            <b-row v-if="question.type == 'متعدد الأختيارات و اجابة'">
                <b-col lg="6" v-for="(answer, i) in question.type_1_answers" :key="i">
                    <b-row>
                        <b-col lg="6">
                            <b-form-group label="الاجابة">
                                <b-form-input v-model="question.type_1_answers[i].answer" />
                            </b-form-group>
                        </b-col>
                        <b-col lg="6">
                            <b-form-radio v-model="question.correctAnswerIndex" :name="'answer_group_' + question._uid"
                                :value="i" class="mt-2">صحيحة</b-form-radio>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <b-row v-if="question.type == 'ترتيب الأجابات'">
                <b-col lg="12">
                    <b-row v-for="(answer, i) in question.type_4_answers" :key="i">
                        <b-col lg="6">
                            <b-form-group label="الاجابة">
                                <b-form-input v-model="question.type_4_answers[i].answer" />
                            </b-form-group>
                        </b-col>
                        <b-col lg="6">
                            <b-form-group label="الترتيب">
                                <b-form-input v-model="question.type_4_answers[i].order" type="number" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>


            </b-row>

            <b-row
                v-if="question.type == 'ملء الفراغ' || question.type == 'مقالي طويل' || question.type == 'مقالي قصير' || question.type == 'مقالي مركب'">

                <b-col lg="12">
                    <b-form-group label="الاجابة">
                        <textarea v-model="question.correct_answer_text" class="form-control"></textarea>
                    </b-form-group>
                </b-col>
            </b-row>

            <hr>

        </div>
    </div>

</template>

<script>

export default {
    props: ['questions'],
    data() {
        return {
            types: [
                // 'توصيل الأجابة الصحيحة',
                'صح و خطأ',
                'ترتيب الأجابات',
                'ملء الفراغ',
                'متعدد الأختيارات و اجابة',
                'متعدد الأختيارات و اجابات',
                'مقالي طويل',
                'مقالي قصير',
                'مقالي مركب'
            ]
        }
    },
    methods: {
        addQuestion() {
            this.questions.push({
                question: '',
                type: '',
                education_results: '',
                difficulty: '',
                cognitive_ability: '',
                mark: '',
                type_1_answers: Array(4).fill(null).map(() => ({ answer: '' })),

                type_2_answer: '',
                type_3_answers: Array(4).fill(null).map(() => ({ answer: '' })),

                type_4_answers: Array(8).fill(null).map(() => ({ answer: '', order: '' })),
                correct_answer: '',
                correct_answer_text: '',
                owner: '',
                correctAnswerIndex: null,
                correctAnswersIndexes: []

            })
        },
        removeQuestion(index) {
            this.questions.splice(index, 1)
        }
    }
}

</script>